//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import noticeVaribaleDialog from '../../components/noticeVaribaleDialog.vue';
import QuillEditorVue from './quillEditor.vue';

export default {
  name: '',
  components: {
    noticeVaribaleDialog,
    QuillEditorVue,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      systemMessageTypeList: [],
      varDiaShow: false,
      varType: '', // var title content
      noticeContent: '',
    };
  },
  computed: {
    variableText() {
      if (this.varType === 'var') {
        return this.value.metadata.to[0] || '';
      }
      return '';
    },
  },
  watch: {
    noticeContent(val) {
      this.valueUpdate('metadata.content', val);
    },
  },
  created() {},
  beforeMount() {},
  mounted() {
    this.getInmailTypeList();
    this.noticeContent = this.value.metadata.content;
    this.$refs.quillEditor.initHtml(this.value.metadata.content);
  },
  methods: {
    valueUpdate(path, value) {
      this.$emit('update', path, value);
    },
    getInmailTypeList() {
      this.$request({
        url: this.$api.metaGetObjectByName,
        data: {
          objects: ['message'],
        },
        cb: ({ list }) => {
          if (list.length) {
            const field = list[0].fields.filter(({ name }) => name === 'type');
            this.systemMessageTypeList = field[0].select_one_option.options;
            const systemNoticeVar =
              field[0].select_one_option.options.find((item) => item.label === '系统通知')?.value ||
              '';
            if (!this.value.metadata.msg_type) {
              this.valueUpdate('metadata.msg_type', systemNoticeVar);
            }
          }
        },
      });
    },
    openVariantDia() {
      this.varType = 'var';
      this.varDiaShow = true;
    },
    openTitleDia() {
      this.varType = 'title';
      this.varDiaShow = true;
    },
    openContentDia() {
      this.varType = 'content';
      this.varDiaShow = true;
    },
    insertVariable(e) {
      switch (this.varType) {
        case 'var':
          this.valueUpdate('metadata.to', [e]);
          return;
        case 'title':
          this.valueUpdate('metadata.subject', this.value.metadata.subject + e);
          return;
        case 'content':
          this.$refs.quillEditor.insertText(e);
          return;
      }
    },
  },
};
